import CallToActionButton from '@/src/common/components/marketing/buttons/CallToActionButton'

export const ActionButtons = ({
    defaultToPredesign,
}: {
    defaultToPredesign: boolean
}) => {
    const ctaUrl = defaultToPredesign
        ? '/corporate/visa/predesign'
        : '/corporate/visa/cobrand'
    const ctaText = defaultToPredesign
        ? 'Buy in bulk using your business logo.'
        : 'Buy in bulk using your own company logo and image.'
    const cta2Url = '/visa-gift-card-box?step=2'
    const cta2Text = `
        Create custom gift cards. Order in bulk and get them delivered together.
    `
    return (
        <div style={{ marginTop: 25 }}>
            <CallToActionButton
                url={ctaUrl}
                text={ctaText}
                header={'Corporate Visa Gift Cards'}
                gradientColor="gradientBorderDefault"
            />
            <CallToActionButton
                url={cta2Url}
                text={cta2Text}
                header={'Visa Gift Cards in a Box'}
                gradientColor={'gradientBorderBlue'}
                customSVG={'/images/blue_gradient_box.svg'}
            />
        </div>
    )
}

export default ActionButtons
